// extracted by mini-css-extract-plugin
export default {"aboutTitle":"styles_aboutTitle__jlPGi","payInFont":"styles_payInFont__7WUii","cancelBtn":"styles_cancelBtn__WoP+d"};